module.exports = __webpack_public_path__ + "static/media/CheckboxChecked.4d16f70b.svg";